<form [formGroup]="form">
  <div class="grid grid-nogutter">
    <div class="col-12 mb-3 p-field p-fluid">
      <p-dropdown
        [options]="reasons"
        formControlName="reason"
        optionLabel="label"
        [filter]="false"
        filterBy="label"
        [showClear]="true"
        [placeholder]="'common.select_a_reason'|translate">
      </p-dropdown>
      <div *ngIf="form.get('reason').invalid && form.get('reason').touched" class="app-form-error">
        <div>{{ form.get('reason')['errorMessage'] }}</div>
        <div *ngIf="form.get('reason').errors?.custom">{{ form.get('reason').errors?.custom }}</div>
      </div>
    </div>
    <div class="col-12 p-field p-fluid">
      <textarea
        pInputTextarea
        [autoResize]="true"
        [placeholder]="'shared.modal.modal_service.report_violation.details'|translate"
        [formControlName]="'details'"
        [style]="{'height':'200px'}"
      ></textarea>
      <div *ngIf="form.get('details').invalid && form.get('details').touched" class="app-form-error">
        <div>{{ form.get('details')['errorMessage'] }}</div>
        <div *ngIf="form.get('details').errors?.custom">{{ form.get('details').errors?.custom }}</div>
      </div>
    </div>
  </div>
</form>
